<div class="vo-panel vo-progress">
  <div class="vo-progress__head">
    <span class="vo-progress__label">{{ flowLabel }}</span>
    <span class="vo-progress__pct">{{ percent }}%</span>
  </div>
  <div class="vo-progress__bar" role="progressbar" aria-valuemin="0" aria-valuemax="100"
       [attr.aria-valuenow]="percent" [attr.aria-label]="'Fortschritt ' + flowLabel">
    <div class="vo-progress__fill" [style.width.%]="percent"></div>
  </div>
  <div class="vo-progress__time">
    <app-icon name="clock" [size]="14"/>
    <span>
      ca. {{ minutesLeft }} Min. übrig
      <span class="vo-progress__count">· Schritt {{ currentIndex + 1 }} von {{ steps.length }}</span>
    </span>
  </div>
</div>

<nav class="vo-panel vo-steps" aria-label="Schritte der Anfrage">
  <ol>
    <li *ngFor="let step of steps; let i = index">
      <button type="button" class="vo-steps__item"
              [class.is-current]="i === currentIndex"
              [class.is-done]="i < currentIndex"
              [disabled]="i >= currentIndex"
              [attr.aria-current]="i === currentIndex ? 'step' : null"
              (click)="goTo(step)">
        <span class="vo-steps__dot">
          <app-icon [name]="step.icon" [size]="16"/>
          <span class="vo-steps__check"><app-icon name="check" [size]="9" [strokeWidth]="4"/></span>
        </span>
        <span class="vo-steps__label">
          {{ step.label }}
          <span class="vo-sr-only" *ngIf="i < currentIndex">(erledigt)</span>
        </span>
      </button>
    </li>
  </ol>
</nav>

<ul class="vo-sidebar__trust">
  <li>
    <app-icon name="circle-check" [size]="16"/>
    Kostenlos &amp; unverbindlich
  </li>
  <li>
    <svg class="vo-flag" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <rect width="24" height="24" fill="#D52B1E"/>
      <path d="M10.5 5h3v14h-3z" fill="#fff"/>
      <path d="M5 10.5h14v3H5z" fill="#fff"/>
    </svg>
    nur Schweizer Unternehmen
  </li>
</ul>
